export default {
  namespaced: true,
  totem_logs: {
    title: "totem logs",
    data: "datos",
    host: "host",
    response: "respuesta",
  },
};
